export default "__VITE_ASSET__BNU60vGH__"